import React from "react";
import { Controller, Control, FieldValues, Path } from "react-hook-form";
import { OptionsDataType } from "../select/MuiSelect";

interface FormAutoCompleteControllerProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  children: React.ReactElement<{
    value?: OptionsDataType | null;
    onChange?: (
      event: React.SyntheticEvent,
      value: OptionsDataType | null,
    ) => void;
    onBlur?: () => void;
    options?: OptionsDataType[];
    error?: boolean;
    helperText?: string;
  }>;
}

export function FormAutoCompleteController<T extends FieldValues>({
  control,
  name,
  children,
}: FormAutoCompleteControllerProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const options = children.props.options || [];
        const selectedOption = options.find((opt) => opt.id === field.value);
        const safeValue = selectedOption ?? null;

        return React.cloneElement(children, {
          value: safeValue,
          onChange: (
            _event: React.SyntheticEvent,
            selected: OptionsDataType | null,
          ) => {
            field.onChange(selected?.id ?? "");
            if (children.props.onChange) {
              children.props.onChange(_event, selected);
            }
          },
          onBlur: () => {
            field.onBlur();
            if (children.props.onBlur) {
              children.props.onBlur();
            }
          },
          error: !!fieldState.error,
          helperText: fieldState.error?.message,
        });
      }}
    />
  );
}
